// Fix voor de quantity selector labels
document.addEventListener('DOMContentLoaded', function() {
  // Wacht tot de DOM is geladen
  setTimeout(function() {
    // Zoek alle quantity selector elementen
    const quantityLabels = document.querySelectorAll('.product-form__quantity .form__label');
    const minusButtons = document.querySelectorAll('.quantity__button[name="minus"] .visually-hidden');
    const plusButtons = document.querySelectorAll('.quantity__button[name="plus"] .visually-hidden');
    
    // Specifieke fix voor premium template
    const premiumLabels = document.querySelectorAll('.quantity-selector-container label');
    premiumLabels.forEach(function(label) {
      if (label.textContent.includes('{"LABEL')) {
        label.textContent = 'Aantal';
      }
    });
    
    // Fix voor de JSON-weergave in tekstvorm
    document.querySelectorAll('*').forEach(function(el) {
      // Controleer alle elementen met tekst die lijkt op JSON-sleutels
      const text = el.textContent || '';
      if (text.includes('LABEL') && text.includes('AANTAL') && 
          (text.includes('INCREASE') || text.includes('DECREASE'))) {
        // Verwijder het hele element of vervang het met een schoon element
        if (el.parentNode) {
          // Alleen specifieke tekst vervangen als het label of button is
          if (el.classList.contains('form__label')) {
            el.textContent = 'Aantal';
          } else if (el.closest('.quantity__button[name="minus"]')) {
            el.textContent = 'Aantal verlagen';
          } else if (el.closest('.quantity__button[name="plus"]')) {
            el.textContent = 'Aantal verhogen';
          } else {
            // Verwijder het volledige element als het onbekend is
            console.log('Verwijderen van JSON-weergave element:', el);
            el.parentNode.removeChild(el);
          }
        }
      }
    });
    
    // De oorspronkelijke aanpak als bovenstaande niet werkt
    quantityLabels.forEach(function(label) {
      if (label.textContent.includes('LABEL')) {
        label.textContent = 'Aantal';
      }
    });
    
    minusButtons.forEach(function(button) {
      if (button.textContent.includes('DECREASE')) {
        button.textContent = 'Aantal verlagen';
      }
    });
    
    plusButtons.forEach(function(button) {
      if (button.textContent.includes('INCREASE')) {
        button.textContent = 'Aantal verhogen';
      }
    });
    
    // Fix voor input attributen
    document.querySelectorAll('input.quantity__input, input.quantity-input').forEach(function(input) {
      // Herstel het label-attribuut als dat het probleem is
      if (input.getAttribute('aria-label') && input.getAttribute('aria-label').includes('LABEL')) {
        input.setAttribute('aria-label', 'Aantal');
      }
    });
    
    // Extra check voor de specifieke weergave in de afbeelding
    const jsonTextElements = document.querySelectorAll('body *');
    jsonTextElements.forEach(function(el) {
      if (el.textContent && (el.textContent.includes('{"LABEL"->"AANTAL"') || el.textContent.includes('{"LABEL"=>"AANTAL"'))) {
        console.log('JSON tekst gevonden en verwijderd:', el);
        el.parentNode.removeChild(el);
      }
    });
    
  }, 1000); // Verhoog de wachttijd naar 1 seconde om zeker te zijn dat alles is geladen
}); 